import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type QuizCreatorCreateQuizMutationVariables = Types.Exact<{
  input: Types.CreateQuizInput;
}>;


export type QuizCreatorCreateQuizMutation = { createQuiz: { quiz?: { id: string } | null } };


export const QuizCreatorCreateQuizDocument = /*#__PURE__*/ gql`
    mutation quizCreatorCreateQuiz($input: CreateQuizInput!) {
  createQuiz(input: $input) {
    quiz {
      id
    }
  }
}
    `;

export function useQuizCreatorCreateQuizMutation() {
  return Urql.useMutation<QuizCreatorCreateQuizMutation, QuizCreatorCreateQuizMutationVariables>(QuizCreatorCreateQuizDocument);
};